import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectMembersListingConfiguration(
    req: Boundaries["editProjectMembersListingConfiguration"]["request"],
  ): void;
}

function useEditProjectMembersListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectMembersListingConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectMembersListingConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectMembersListingConfigurationRequestFailure(planzone),
    ),
    editProjectMembersListingConfiguration:
      core.editProjectMembersListingConfiguration,
  };
}

export { useEditProjectMembersListingConfiguration };
